<template>
  <!-- <div id="app"> -->
  <a-config-provider :locale="locale">
    <a-layout>
      <a-layout-sider class="sidemenu" :class="{active:sideOpen}">
        <!-- <SideMenu /> -->
      </a-layout-sider>
      <a-layout-content style="background:hsla(206, 47%, 98%, 1); overflow-x: visible">
        <Navbar />
        <router-view class="router-view" />
        <footer class="footer">
          <div class="desc">
            <div>{{$t('nav.help')}}</div>
            <div>{{$t('nav.privacy')}}</div>
            <div>{{$t('nav.provision')}}</div>
          </div>
          <div class="copyright">Copyright ©️ 2018-{{new Date().getFullYear()}} {{$t('label.copyright')}}</div>
        </footer>
      </a-layout-content>
    </a-layout>
  </a-config-provider>
  <!-- <FloatMenu class="float-menu" /> -->
  <!-- </div> -->
</template>

<script>
// import SideMenu from "./SideMenu";
import Navbar from "./Navbar";
import { mapGetters } from "vuex";
import zh from "ant-design-vue/lib/locale-provider/zh_CN";
import en from "ant-design-vue/lib/locale-provider/en_US";
const msg = { zh, en };
// import FloatMenu from "@/views/home/FloatMenu";
import { getLanguage } from "@/locales";
export default {
  components: { Navbar },
  name: "App",
  data() {
    return {
      locale: msg[getLanguage()],
      activeIndex: "index",
      showMenu: true
    };
  },
  computed: {
    ...mapGetters(["user", "sideOpen"])
  },
  mounted() {
    console.log("user:", this.user);
  },
  watch: {
    $route(to, from) {
      console.log("route from:", from);
      if (to.path == "/login") {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
    }
  },
  methods: {
    toHome() {
      this.$router.push({ name: "home" });
    },
    toSetting() {
      this.$router.push({ name: "setting" });
    },
    handleSelect(e) {
      if (e === "index") {
        this.$router.push({ path: "/main" });
      }
      if (e == "process") {
        this.$router.push({ path: "/process" });
      }
      if (e == "week") {
        this.$router.push({ path: "/week" });
      }
      if (e == "task") {
        this.$router.push({ path: "/mission" });
      }
      if (e == "create_task") {
        this.$router.push({ path: "/create_mission" });
      }

      if (e === "logout") {
        localStorage.clear();
        this.$router.push({ path: "/login" });
      }
    },
    toLogout() {
      this.$confirm({
        title: "确认退出么??？",
        onOk() {
          this.$store.dispatch("logout").then(() => {
            this.$router.push({ name: "login" });
          });
        }
      });
    }
  }
};
</script>
<style>
.link .router-link-active {
  color: #fff;
}

.oa-box {
  box-shadow: 0px 2px 6px 0px rgba(26, 20, 61, 0.04);
  border-radius: 4px;
  background: #fff;
}

.inline-middle {
  display: inline-flex;
  align-items: center;
}
</style>
<style lang="scss" scoped>
//  #app {
// margin: 0;
// padding: 0;
// position: relative;
.sidemenu {
  position: absolute;
  left: -250px;
  top: 0;
  z-index: 2;
  width: 250px;
  min-height: 100vh;
}
.sidemenu.active {
  left: 0;
}

.router-view {
  background: rgb(243, 247, 255);
  // height: calc(100vh - 105px);
  padding: 0 24px 24px;
  // overflow-y: auto;
}

.footer {
  height: 106px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: flex-end;
  color: hsla(0, 0%, 0%, 0.45);
  background: hsla(205, 46%, 97%, 1);
  .desc {
    align-self: center;
    display: flex;
    align-items: center;
    margin: 32px 0 8px;
    > div {
      margin: 0 20px;
    }
  }
  .copyright {
    margin: 8px 0;
    font-size: smaller;
  }
}
// }
@media screen and (max-width: 480px) {
  // #app {
  .nav {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .nav-link {
      width: 100%;
      order: 2;
      img {
        width: 97px;
        height: 16px;
        margin-right: 10px;
      }
    }
    .nav-user {
      width: 100%;
      order: 1;
      padding: 0 5px;
      .icon {
        margin: 0 15px;
      }
      .user-head {
        min-width: 90px;
      }
      .icon-gap {
        margin: 0;
      }
    }
  }
}
body /deep/ .el-message-box {
  width: 80%;
}
// }
</style>

